/* eslint-disable react/prop-types */
import React from 'react';
import { connect } from 'react-redux';
import { Formik } from 'formik';
import toastr from 'toastr';
import {
  FormGroup,
  Form,
  Label,
  Input,
  Row,
  Col,
} from 'reactstrap';
import { injectIntl } from 'react-intl';


import Content from '../components/layout/Content';
import FormError from '../components/formControls/FormError';
import SnipperButton from '../components/buttons/SpinnerButton';

import { addUserSchema } from '../validations';
import { addUser } from '../api/user';

class AddUserForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
  }

  render() {
    const { intl, masterUser } = this.props;
    const { loading } = this.state;
    const emailText = intl.formatMessage({ id: 'addUser.email' });
    const passwordText = intl.formatMessage({ id: 'addUser.password' });
    const addButtonText = intl.formatMessage({ id: 'addUser.add' });
    const title = intl.formatMessage({ id: 'addUser.title' });
    const nameText = intl.formatMessage({ id: 'addUser.name' });
    const successText = intl.formatMessage({ id: 'addUser.success' });

    return (
      <Row>
        <Col>
          <Formik
            initialValues={{ name: '', email: '', password: '' }}
            validationSchema={addUserSchema}
            onSubmit={async (user, { resetForm }) => {
              const data = {
                ...user,
                masterUser: masterUser.id,
              };
              this.setState({ loading: true });
              try {
                const res = await addUser(data);
                this.setState({ loading: false });
                if (!res.data.error) {
                  resetForm();
                  return toastr.success(successText);
                }
              } catch (err) {
                this.setState({ loading: false });
                return toastr.error(intl.formatMessage({ id: `validations.${err.response.status}` }));
              }
              return toastr.error(intl.formatMessage({ id: 'error' }));
            }}
          >
            {({
              values,
              errors,
              handleChange,
              handleBlur,
              handleSubmit,
              /* and other goodies */
            }) => (
              <Content title={title}>
                  <Form onSubmit={handleSubmit}>
                    <FormGroup>
                      <Label for="name">{nameText}</Label>
                      <Input
                        type="text"
                        name="name"
                        id="name"
                        placeholder={nameText}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.name}
                      />
                      {errors.name && <FormError error={errors.name} />}
                    </FormGroup>
                    <FormGroup>
                      <Label for="email">{emailText}</Label>
                      <Input
                        type="email"
                        name="email"
                        id="email"
                        placeholder={emailText}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.email}
                      />
                      {errors.email && <FormError error={errors.email} />}
                    </FormGroup>
                    <FormGroup>
                      <Label for="password">{passwordText}</Label>
                      <Input
                        type="password"
                        name="password"
                        id="password"
                        placeholder={passwordText}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.password}
                      />
                      {errors.password && <FormError error={errors.password} />}
                    </FormGroup>
                    <SnipperButton type="submit" loading={loading} text={addButtonText} />
                  </Form>
                </Content>
            )}
          </Formik>
        </Col>
      </Row>
    );
  }
}
const mapStateToProps = (state) => ({ masterUser: state.auth.user });
export default injectIntl(connect(mapStateToProps)(AddUserForm));
